module.exports = __webpack_public_path__ + "img/yufei-logo-footer.f6f293d4.png";